module.exports = __webpack_public_path__ + "static/easy-manage-a47df834c7813da3b543ea9799bbd51c.png";